/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
export const formatPhoneNumberNoPrefix = (value) => {
    if (!value) return value
    const phoneNumber = value.replace(/[^\d]/g, '')
    return phoneNumber
}

export const validateNumber = (value) => {
    return {
        vatNumber: value && /^([A-Z]{2})([0-9A-Za-z+*.]{2,12})$/.test(value),
    }
}

export const validateVatNumber = (value, countryCode) => {
    const regexes = {
        IT: /^IT[A-Za-z0-9]{11}$/,
        ES: /^ES[A-Za-z0-9]{9}$/,
        FR: /^FR[A-Za-z0-9]{11}$/,
        BE: /^BE[A-Za-z0-9]{10}$/,
        PL: /^PL[A-Za-z0-9]{10}$/,
        DE: /^DE[A-Za-z0-9]{9}$/,
    }
    let vatNumber = true
    if (countryCode && regexes[countryCode]) {
        vatNumber = regexes[countryCode].test(value)
    } else {
        vatNumber = value && /^([A-Z]{2})([0-9A-Za-z+*.]{2,12})$/.test(value)
    }
    return {vatNumber}
}
